import React from 'react';
import LessonPlannerRouter from '../containers/LessonPlannerRouter';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';
import AiRestrictionContextProvider from '../contexts/AiRestrictionContextProvider';

export default ({ isDemo = false, aiRestrictedGroup = null, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <AiRestrictionContextProvider aiRestrictedGroup={aiRestrictedGroup}>
      <LessonPlannerRouter {...props} />
    </AiRestrictionContextProvider>
  </DemoAccountContextProvider>
);
